import { render, staticRenderFns } from "./VDesignChatHeader.vue?vue&type=template&id=bca4f59e&"
import script from "./VDesignChatHeader.vue?vue&type=script&lang=ts&"
export * from "./VDesignChatHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignChatHeader.vue?vue&type=style&index=0&id=bca4f59e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports